import {
  getActionNameWithStatus,
  getResetAction,
} from "../../constants/actions-methods";
import { requestStatus } from "../../constants/request";
import { serverApis } from "../../constants/server-apis";

export const floorPlanReducer = (state = [], action) => {
  const actionName = serverApis.getFloorPlan.actionName;
  switch (action.type) {
    case getActionNameWithStatus(actionName, requestStatus.SUCCESS):
      return action.json.catalog_item_locations;

    case getResetAction(actionName):
      return [];
    default:
      return state;
  }
};
